import { ServiceCategory, NewServiceCategory } from '../../models/Entities/ServiceCategory';
import { AppThunkAction } from '../reducers';
import { ErrorType } from '../../models/HttpError';

// services
import * as Services from '../../services/ServiceCategory.Services';

// Actions
import * as Actions from '../actions/ServiceCategory.Actions';

type KnownAction =
  | Actions.ServiceCategoryGetAll_Request_Action
  | Actions.ServiceCategoryGetAll_Receive_Action
  | Actions.ServiceCategoryGetAll_Fail_Action
  | Actions.ServiceCategoryUpdateAll_Request_Action
  | Actions.ServiceCategoryUpdateAll_Receive_Action
  | Actions.ServiceCategoryUpdateAll_Fail_Action
  | Actions.ServiceCategoryGetById_Request_Action
  | Actions.ServiceCategoryGetById_Receive_Action
  | Actions.ServiceCategoryGetById_Fail_Action
  | Actions.ServiceCategoryAdd_Request_Action
  | Actions.ServiceCategoryAdd_Receive_Action
  | Actions.ServiceCategoryAdd_Fail_Action
  | Actions.ServiceCategoryUpdate_Request_Action
  | Actions.ServiceCategoryUpdate_Receive_Action
  | Actions.ServiceCategoryUpdate_Fail_Action
  | Actions.ServiceCategoryDelete_Request_Action
  | Actions.ServiceCategoryDelete_Receive_Action
  | Actions.ServiceCategoryDelete_Fail_Action;

export const actionCreators = {
  GetAllServiceCategories: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
    const state = getState();
    if (state.ServiceCategories?.isLoadingAll || state.ServiceCategories?.successLoadingAll) return;

    if (!state.ServiceCategories?.successLoadingAll) {
      dispatch({
        type: 'SERVICE_CATEGORY_GET_ALL_REQUEST_ACTION'
      });

      Services.GetAllServiceCategories()
        .then((serviceCategories: ServiceCategory[]) => {
          dispatch({
            type: 'SERVICE_CATEGORY_GET_ALL_RECEIVE_ACTION',
            ServiceCategories: serviceCategories
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_GET_ALL_FAIL_ACTION',
            error: error
          })
        );
    } else {
      dispatch({
        type: 'SERVICE_CATEGORY_UPDATE_ALL_REQUEST_ACTION'
      });

      Services.GetAllServiceCategories()
        .then((serviceCategories: ServiceCategory[]) => {
          dispatch({
            type: 'SERVICE_CATEGORY_UPDATE_ALL_RECEIVE_ACTION',
            ServiceCategories: serviceCategories
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_UPDATE_ALL_FAIL_ACTION',
            error: error
          })
        );
    }
  },

  GetServiceCategoryById:
    (serviceCategoryId: string): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_CATEGORY_GET_BY_ID_REQUEST_ACTION',
        ServiceCategoryId: serviceCategoryId
      });

      Services.GetServiceCategoryById(serviceCategoryId)
        .then((serviceCategory: ServiceCategory) => {
          dispatch({
            type: 'SERVICE_CATEGORY_GET_BY_ID_RECEIVE_ACTION',
            ServiceCategory: serviceCategory
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_GET_BY_ID_FAIL_ACTION',
            error: error
          })
        );
    },

  AddServiceCategory:
    (newServiceCategory: NewServiceCategory): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_CATEGORY_ADD_REQUEST_ACTION',
        NewServiceCategory: newServiceCategory
      });

      Services.CreateServiceCategory(newServiceCategory)
        .then((serviceCategory: ServiceCategory) => {
          dispatch({
            type: 'SERVICE_CATEGORY_ADD_RECEIVE_ACTION',
            ServiceCategory: serviceCategory
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_ADD_FAIL_ACTION',
            error: error
          })
        );
    },

  UpdateServiceCategory:
    (serviceCategory: ServiceCategory): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_CATEGORY_UPDATE_REQUEST_ACTION',
        ServiceCategory: serviceCategory
      });

      Services.UpdateServiceCategory(serviceCategory.id, serviceCategory)
        .then((updatedServiceCategory: ServiceCategory) => {
          dispatch({
            type: 'SERVICE_CATEGORY_UPDATE_RECEIVE_ACTION',
            ServiceCategory: updatedServiceCategory
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_UPDATE_FAIL_ACTION',
            error: error
          })
        );
    },

  DeleteServiceCategory:
    (serviceCategoryId: string): AppThunkAction<KnownAction> =>
    async (dispatch) => {
      dispatch({
        type: 'SERVICE_CATEGORY_DELETE_REQUEST_ACTION',
        ServiceCategoryId: serviceCategoryId
      });

      Services.DeleteServiceCategory(serviceCategoryId)
        .then(() => {
          dispatch({
            type: 'SERVICE_CATEGORY_DELETE_RECEIVE_ACTION',
            ServiceCategoryId: serviceCategoryId
          });
        })
        .catch((error: ErrorType) =>
          dispatch({
            type: 'SERVICE_CATEGORY_DELETE_FAIL_ACTION',
            error: error
          })
        );
    }
};
